import { render, staticRenderFns } from "./EmbeddedPresentation.vue?vue&type=template&id=b98773b6&scoped=true&"
import script from "./EmbeddedPresentation.vue?vue&type=script&lang=js&"
export * from "./EmbeddedPresentation.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedPresentation.vue?vue&type=style&index=0&id=b98773b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98773b6",
  null
  
)

export default component.exports